import { render, staticRenderFns } from "./ReportDescriptions.vue?vue&type=template&id=51a7f236&scoped=true&"
import script from "./ReportDescriptions.vue?vue&type=script&lang=js&"
export * from "./ReportDescriptions.vue?vue&type=script&lang=js&"
import style0 from "./ReportDescriptions.vue?vue&type=style&index=0&id=51a7f236&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a7f236",
  null
  
)

export default component.exports